<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'role'
    }
</script>

<style lang="scss" scoped>

</style>